import {HttpStatusCode} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {DomainToolCompany} from '@app/model/domain-tool/dcp-company.model';
import {DcpApiService, DcpGlobalMessageService, DcpLoggingService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DomainToolService {

  private companies: Observable<DomainToolCompany[]> = undefined;

  constructor(private apiService: DcpApiService,
              private dcpGlobalMessageService: DcpGlobalMessageService,
              private dcpLoggingService: DcpLoggingService) {
  }

  getCompanies(): Observable<DomainToolCompany[]> {
    if (this.companies) {
      return this.companies;
    } else {
      this.companies = this.getDomainToolCompanies();
      return this.companies;
    }
  }

  private getDomainToolCompanies(): Observable<DomainToolCompany[]> {
    return this.apiService.callKyma<DomainToolCompany[]>('domainTool', 'matchingCompanies')
      .pipe(
        untilDestroyed(this),
        catchError((e) => {
          if (e.status === HttpStatusCode.NotFound) {
            this.dcpLoggingService.info('No matching companies found', this?.constructor?.name);
            return of([]);
          }
          this.dcpGlobalMessageService.addMessage(e, this?.constructor?.name, 'errorLogging');
          throw (e);
        })
      );
  }
}
